import Header from '../components/Header';
import Footer from '../components/Footer';
import React from 'react';
const OurEvents = () => {
    return (
        <div>
             <Header/>
      
            <div>
                <div className="page-heading header-text">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h1>Our Events & Activities</h1>
                                <span>EMPOWERING YOUR TECH JOURNEY EVERY STEP OF THE WAY</span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="single-services">
                    <div className="container">
                        <div className="row" id="tabs">
                            <div className="col-md-4">
                                <ul>
                                    <li><a href='#tabs-1'>Technical Workshops <i className="fa fa-angle-right"></i></a></li>
                                    <li><a href='#tabs-2'>Coding Competitions <i className="fa fa-angle-right"></i></a></li>
                                    <li><a href='#tabs-3'>Community Projects <i className="fa fa-angle-right"></i></a></li>
                                    <li><a href='#tabs-4'>Networking Events <i className="fa fa-angle-right"></i></a></li>
                                </ul>
                            </div>
                            <div className="col-md-8">
                                <section className='tabs-content'>
                                    <article id='tabs-1'>
                                        <img src="assets/images/workshop2.jpg" alt="Technical Workshops" />
                                        <h4>Technical Workshops</h4>
                                        <p>
                                            Immerse yourself in hands-on learning experiences with our comprehensive technical workshops. From Flutter and mobile development to web technologies and emerging frameworks, our expert-led sessions provide practical knowledge you can apply immediately. Recent highlights include our Flutter & Mobile Development workshop with trainer Hamed, which equipped participants with real-world app development skills through collaborative coding sessions and project-based learning.
                                            <br /><br />
                                        </p>
                                        <a href="/Timeline" className="filled-button" style={{ marginTop: '15px' }}>Learn More</a>
                                    </article>
                                    <article id='tabs-2'>
                                        <img src="assets/images/competition.jpg" alt="Coding Competitions" />
                                        <h4>Coding Competitions</h4>
                                        <p>
                                            Challenge your problem-solving abilities and showcase your programming prowess through our exciting competitions. Events like the "Play4Hope Cup" and "Land It!" bring together the brightest minds from ISI and beyond, creating an environment where innovation thrives and friendships are forged. These competitions not only test your technical skills but also teach valuable lessons about teamwork, time management, and creative thinking under pressure.
                                            <br /><br />
                                        </p>
                                        <a href="/Timeline" className="filled-button" style={{ marginTop: '15px' }}>Learn More</a>
                                    </article>
                                    <article id='tabs-3'>
                                        <img src="assets/images/community.jpg" alt="Community Projects" />
                                        <h4>Community Service Projects</h4>
                                        <p>
                                            We believe technology should serve humanity, which is why community impact is at the heart of what we do. Our initiatives, such as organizing iftar meals for children at Dar Maram during Ramadan, demonstrate how tech professionals can give back to society. These projects teach us that the most meaningful code is the one that makes a positive difference in people's lives, fostering empathy and social responsibility alongside technical excellence.
                                            <br /><br />
                                        </p>
                                        <a href="/Timeline" className="filled-button" style={{ marginTop: '15px' }}>Learn More</a>
                                    </article>
                                    <article id='tabs-4'>
                                        <img src="assets/images/networking.jpg" alt="Networking Events" />
                                        <h4>Networking Events</h4>
                                        <p>
                                            Build lasting professional relationships and expand your career opportunities through our carefully curated networking events. These gatherings connect students with industry professionals, alumni, and fellow tech enthusiasts, creating a supportive ecosystem for knowledge exchange and mentorship. Whether you're seeking internship opportunities, looking for project collaborators, or simply want to share your passion for technology, our networking events provide the perfect platform for meaningful connections.
                                            <br /><br />
                                        </p>
                                        <a href="/Timeline" className="filled-button" style={{ marginTop: '15px' }}>Learn More</a>
                                    </article>
                                    
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <Footer/>
        </div>
    );
};
export default OurEvents;